import React from "react"
import { Redirect } from "react-router"

export function Home() {
    
    return <Redirect to="/selectDeclarante" />
}
